import React from 'react';
import { Blank } from 'tea-component';

function NotFoundPage() {
  return <Blank theme="error" description="404 Not Found" />;
}

export default NotFoundPage;
